
export interface Memory {
    id: string;
    title: string;
    description: string;
    date: Date;
    type: string;
    mediaUrl: string;
    mediaType: 'IMAGE' | 'VIDEO';  // Add this property
}

export class MemoryImpl implements Memory {
    constructor(
        public id: string,
        public title: string,
        public description: string,
        public date: Date,
        public type: string,
        public mediaUrl: string,
        public mediaType: 'IMAGE' | 'VIDEO'  // Add this parameter
    ) {}
}